var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search" }, [
    !_vm.closeOffline && _vm.isOffline
      ? _c("div", { staticClass: "v3offline" }, [
          _c("i", { staticClass: "icon-exclamation-mark-circle" }),
          _vm._v(" "),
          _c("p", [_vm._v("未連接至網路")]),
          _vm._v(" "),
          _c("div", { on: { click: _vm.closeOfflineHandle } }, [
            _c("i", { staticClass: "icon-close" })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "search__block" }, [
      _c("div", { staticClass: "search__panel" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchWords,
              expression: "searchWords"
            }
          ],
          ref: "autoFocusInput",
          staticClass: "search__panel__input",
          style: [_vm.deleteBtnStatus ? { paddingRight: "40px" } : null],
          attrs: { type: "text", placeholder: "請輸入搜尋關鍵字" },
          domProps: { value: _vm.searchWords },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchWords = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.deleteBtnStatus
          ? _c(
              "div",
              {
                staticClass: "search__panel__cross",
                on: { click: _vm.deleteInputText }
              },
              [_c("i", { staticClass: "icon-close-circle" })]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.deleteBtnStatus
          ? _c(
              "span",
              { staticClass: "search__panel__word", on: { click: _vm.search } },
              [_vm._v("搜尋")]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search__block articleList" },
      [
        _c(
          "mescroll-vue",
          {
            attrs: { down: _vm.getMescrollDown(), up: _vm.getMescrollUp() },
            on: {
              init: function($event) {
                _vm.mescrollInit(arguments)
              }
            }
          },
          [
            _c(
              "ul",
              [
                _vm._l(_vm.news, function(news, news_ind) {
                  return _c(
                    "li",
                    { key: news_ind },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "v3newsDetail",
                              params: { id: news.news_id }
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "articleTag" }, [
                            _vm._v(_vm._s(news.news_type))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "articleContent" }, [
                            news.title_img !== ""
                              ? _c("div", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background-image",
                                      value: news.title_img,
                                      expression: "news.title_img",
                                      arg: "background-image"
                                    }
                                  ],
                                  staticClass: "articleContentImg"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            news.title_img == ""
                              ? _c("div", { staticClass: "articleContentImg" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "articleContentNote" }, [
                              _vm._v(_vm._s(news.title))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "articleContentIcon" }, [
                              _c("i", { staticClass: "icon-right-roundedline" })
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                !_vm.isSearching &&
                _vm.currentSearchingKeyword !== "" &&
                _vm.news.length === 0
                  ? _c("div", { staticClass: "articleListEmpty" }, [
                      _c("i", { staticClass: "icon-empty-status" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("噢不！"),
                        _c("br"),
                        _vm._v("沒有搜尋結果，試試別的關鍵字吧！")
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.v3Toast.show,
            expression: "v3Toast.show"
          }
        ],
        staticClass: "v3Toast"
      },
      [_vm._v(_vm._s(_vm.v3Toast.text))]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "search__panel__magnifier" }, [
      _c("i", { staticClass: "icon-search" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65b642a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b642a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/search.vue
// module id = null
// module chunks = 